import { statusColorMap, statusTextColorMap } from '../../constants/design_system/statusColors';
import { TaskStatusGroup } from '../../types/TaskStatus';
import CustomTooltip from './Tooltip/CustomTooltip';

export enum StatusComponentType {
  Table = 'table',
  TableHeader = 'table_header',
  Dropdown = 'dropdown',
  EditStatusesModal = 'edit_statuses_modal',
  EditStatusesModalColor = 'edit_statuses_modal_color',
  DeleteStatusModal = 'delete_status_modal',
}

export type StatusLabelProps = {
  group: TaskStatusGroup;
  title: string;
  color: 'grey' | 'blue' | 'yellow' | 'orange' | 'red' | 'purple' | 'green';
  component: StatusComponentType;
};

const StatusLabel: React.FC<StatusLabelProps> = (taskStatusProps) => {
  const badgeStyle = {
    backgroundColor: statusColorMap[taskStatusProps.color],
    color: statusTextColorMap[taskStatusProps.color],
  };

  const dotStyle = {
    backgroundColor: statusTextColorMap[taskStatusProps.color],
  };

  const maxWidth = getComponentTextWidth(taskStatusProps.component);

  const textStyle = {
    ...badgeStyle,
    maxWidth: maxWidth,
  };

  const textWidth = getTextWidth(taskStatusProps.title, '14px Figtree');

  const statusLabel = (
    <div style={badgeStyle} className="h-5 max-w-[180px] flex items-center py-1 px-2 rounded text-sm font-normal">
      <div style={dotStyle} className="w-2 h-2 rounded-full mr-1"></div>
      <div style={textStyle} className="h-5 whitespace-nowrap overflow-hidden text-ellipsis">
        {taskStatusProps.title}
      </div>
    </div>
  );

  if (taskStatusProps.component === StatusComponentType.Dropdown || textWidth < maxWidth) {
    return statusLabel;
  }
  return <CustomTooltip title={taskStatusProps.title}>{statusLabel}</CustomTooltip>;
};

function getComponentTextWidth(componentType: StatusComponentType): number {
  switch (componentType) {
    case StatusComponentType.Dropdown:
      return 125;
    case StatusComponentType.EditStatusesModal:
      return 180;
    case StatusComponentType.TableHeader:
      return 500;
    case StatusComponentType.DeleteStatusModal:
      return 125;
    default:
      return 80;
  }
}

function getTextWidth(text: string, font: string): number {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context.font = font;
  return context.measureText(text).width;
}

export default StatusLabel;
